<template>
    <Breadcrumbs
        main="Aspirateur"
        :mains="title"
        title="Aspirateurs de site"
    />
    <div class="container-fluid">
        <div class="row">
            <Card3 colClass="col-sm-12">
                <CrawlerEdit :crawler="crawler" />
                <div class="row">
                    <div class="col">
                        <div class="text-end">
                            <a class="btn btn-success me-1" @click="save()">
                                {{ $t('save') }}
                            </a>
                        </div>
                    </div>
                </div>
            </Card3>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import ApiServices from '@/services/apiServices';
import { useLoaderState } from '@/store/loading';
import { error_message, success_message } from '@/components/common/toast';
import type { crawler } from '@/core/data/crawler';

const CrawlerEdit = defineAsyncComponent(
    () => import('@/components/theme/crawler/CrawlerEdit.vue'),
);

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const crawler = ref<crawler>({
    id: '',
    name: '',
    source: '',
    sourceType: 1,
    message: '',
    status: 'CREATED',
    autoImport: false,
    defaultPageType: 4,
});

const title = computed(() =>
    crawler.value?.id
        ? t('crawlerEdit.updatetitle')
        : t('crawlerEdit.addtitle'),
);

const save = async () => {
    if (!crawler.value.name) {
        error_message(t('crawlerEdit.nameRequired'));
        return;
    }
    if (!crawler.value.source || !/^https?:\/\//i.test(crawler.value.source)) {
        error_message(t('crawlerEdit.sourceInvalid'));
        return;
    }
    useLoaderState().changeStateTrue();
    if (route.query.id) {
        ApiServices.update('crawlers', crawler.value, crawler.value.id)
            .then(() => {
                success_message(t('crawlerEdit.updated'));
                router.push({ name: 'crawlerList' });
            })
            .catch((ex: any) => error_message(ex.message))
            .finally(() => useLoaderState().changeStateFalse());
    } else {
        ApiServices.create('crawlers', crawler.value)
            .then(() => {
                success_message(t('crawlerEdit.saved'));
                router.push({ name: 'crawlerList' });
            })
            .catch((ex: any) => error_message(ex.message))
            .finally(() => useLoaderState().changeStateFalse());
    }
};

const getDatas = async () => {
    if (route.query.id) {
        ApiServices.getById('crawlers', route.query.id.toString()).then(
            (response: any) => {
                crawler.value = response;
            },
        );
    }
};

onMounted(() => {
    useLoaderState().changeStateTrue();
    getDatas();
    useLoaderState().changeStateFalse();
});
</script>
